
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { get } from "lodash";
import { Getter, namespace } from "vuex-class";
import AreaNotesForm from "@/components/area-notes/AreaNotesForm.vue";
import AreaNotesTable from "@/components/area-notes/AreaNotesTable.vue";
import { AreaNote } from "@/store/area-notes/types";

const AreaNotes = namespace("areaNotes");
const SiteMonitor = namespace("siteMonitor");

@Component({
	components: {
		"area-notes-form": AreaNotesForm,
		"area-notes-table": AreaNotesTable
	}
})
export default class AreaNotesModal extends Vue {
	@SiteMonitor.Getter("areaNotesVisible") isShown: boolean;
	
	@AreaNotes.Action public fetchAreaNotesForGroup: (groupId: number) => Promise<void>;
	@AreaNotes.Action closeModal: any;
	@AreaNotes.Getter getCurrentGroupId: number;
	@AreaNotes.Getter getAreaNotes: AreaNote[];
	@AreaNotes.Getter getCurrentGroupTitle: string;

	private notesDataLoading: boolean = false;

	@Watch("isShown") 
	private async dialogShown(): Promise<void> {
		if (this.isShown) {
			 await this.loadNotes();
		}
		else {
			this.notesDataLoading = false;
		}
	}	

	private async loadNotes (): Promise<void> {
			this.notesDataLoading = true;
			await this.fetchAreaNotesForGroup(this.getCurrentGroupId);
			this.notesDataLoading = false;
	}
}
